<template>
  <div>
    <Token v-for="tokenId in tokenIds" :key="tokenId" :tokenId="tokenId" />
  </div>
</template>

<script setup>
  import Token from '../tokens/Token.vue';

  defineProps({
    tokenIds: {
      type: Array,
      required: true,
    },
  });
</script>
